/** Textos de las cards y del detalle de servicios. El castellano vive en servicios.json. */

export const serviciosCopy = {
  composiciones: {
    en: {
      descripcion: 'An original work, a finely judged arrangement, or an orchestration with real presence? Music written to your measure, from the podium.',
      ctaLabel: 'Commission a work',
      detalle: {
        gancho: 'An original work, a finely judged arrangement, or an orchestration with real presence? Music written to your measure, from the podium.',
        intro: 'With more than thirty years on international podiums, and training at the Royal Conservatory of Brussels, I put a conductor’s and opera director’s experience at the service of your project. I compose, arrange and orchestrate with the technical care a major stage demands, and with the musical sense that reaches an audience.',
        cierreTitulo: 'Give your next project a life on the page',
        cierre: 'Whether you need an intimate song or a full symphonic production, let us talk and bring the work into being.',
        secciones: [
          {
            titulo: 'Composition and orchestration to commission',
            items: [
              { titulo: 'Popular music and songs', texto: 'Stylised arrangements and a professional demo, ready to take the music further.' },
              { titulo: 'Intimate forces', texto: 'Exclusive repertoire for voice and piano, or solo instrument and piano.' },
              { titulo: 'Chamber music', texto: 'New works and demanding adaptations for quartet and quintet.' },
              { titulo: 'Large forces', texto: 'Composition and orchestration written for symphony orchestra.' },
              { titulo: 'Large-scale works', texto: 'Symphonies, concertos and complete operas.' },
            ],
          },
          {
            titulo: 'Why these scores work',
            items: [
              { titulo: 'Effective at the stand', texto: 'As Music Director of the Universidad Católica de Temuco Symphony Orchestra and Chorus, and as a guest opera conductor in Santiago with the Orquesta Filodramática de Chile, I know what holds in rehearsal and what carries on stage.' },
              { titulo: 'A true balance of sound', texto: 'Scoring that is balanced, playable, and matched to what your ensemble can actually do.' },
              { titulo: 'Engraving to an international standard', texto: 'Full score and parts, prepared for clear reading at the stand.' },
            ],
          },
        ],
      },
    },
    fr: {
      descripcion: 'Une œuvre originale, un arrangement juste, une orchestration qui porte ? Une musique écrite à votre mesure, depuis le podium.',
      ctaLabel: 'Commander une œuvre',
      detalle: {
        gancho: 'Une œuvre originale, un arrangement juste, une orchestration qui porte ? Une musique écrite à votre mesure, depuis le podium.',
        intro: 'Fort de plus de trente ans sur les podiums internationaux, et formé au Conservatoire royal de Bruxelles, je mets l’expérience du chef d’orchestre et de lyrique au service de votre projet. J’écris, j’arrange et j’orchestre avec la rigueur qu’exigent les grandes scènes, et le sens musical qui rejoint le public.',
        cierreTitulo: 'Donnez vie à votre prochain projet',
        cierre: 'Qu’il s’agisse d’une mélodie intime ou d’une production symphonique, parlons-en et faisons exister l’œuvre.',
        secciones: [
          {
            titulo: 'Composition et orchestration sur commande',
            items: [
              { titulo: 'Musique populaire et chansons', texto: 'Arrangements stylisés et maquette professionnelle, pour faire franchir un cap à votre musique.' },
              { titulo: 'Effectifs intimes', texto: 'Répertoire exclusif pour chant et piano, ou instrument soliste et piano.' },
              { titulo: 'Musique de chambre', texto: 'Création et adaptations exigeantes pour quatuor et quintette.' },
              { titulo: 'Grands effectifs', texto: 'Composition et orchestration écrites pour orchestre symphonique.' },
              { titulo: 'Grandes formes', texto: 'Symphonies, concertos et opéras complets.' },
            ],
          },
          {
            titulo: 'Pourquoi ces partitions tiennent',
            items: [
              { titulo: 'Efficaces sur le pupitre', texto: 'Directeur musical de l’Orchestre et du Chœur symphoniques de l’Universidad Católica de Temuco, et chef invité à l’opéra à Santiago avec l’Orquesta Filodramática de Chile, je sais ce qui fonctionne en répétition et ce qui porte sur scène.' },
              { titulo: 'Un équilibre sonore réel', texto: 'Une instrumentation équilibrée, fluide, adaptée aux moyens réels de votre ensemble.' },
              { titulo: 'Gravure aux standards internationaux', texto: 'Conducteur et parties séparées, préparés pour une lecture claire au pupitre.' },
            ],
          },
        ],
      },
    },
    de: {
      descripcion: 'Ein eigenes Werk, ein präzises Arrangement oder eine Orchestration mit Wirkung? Musik nach Ihrem Maß, vom Pult aus geschrieben.',
      ctaLabel: 'Ein Werk in Auftrag geben',
      detalle: {
        gancho: 'Ein eigenes Werk, ein präzises Arrangement oder eine Orchestration mit Wirkung? Musik nach Ihrem Maß, vom Pult aus geschrieben.',
        intro: 'Mit über dreißig Jahren auf internationalen Podien und einer Ausbildung am Königlichen Konservatorium Brüssel stelle ich die Erfahrung des Dirigenten und Opernleiters in den Dienst Ihres Projekts. Ich komponiere, arrangiere und orchestriere mit der technischen Sorgfalt, die eine große Bühne verlangt, und mit dem musikalischen Sinn, der das Publikum erreicht.',
        cierreTitulo: 'Geben Sie Ihrem nächsten Projekt eine Partitur',
        cierre: 'Ob ein intimes Lied oder eine große sinfonische Produktion: lassen Sie uns sprechen und das Werk entstehen.',
        secciones: [
          {
            titulo: 'Komposition und Orchestration im Auftrag',
            items: [
              { titulo: 'Populäre Musik und Songs', texto: 'Stilisierte Arrangements und eine professionelle Maquette, damit Ihre Musik den nächsten Schritt tut.' },
              { titulo: 'Intime Besetzungen', texto: 'Exklusives Repertoire für Gesang und Klavier oder Soloinstrument und Klavier.' },
              { titulo: 'Kammermusik', texto: 'Neue Werke und anspruchsvolle Bearbeitungen für Quartett und Quintett.' },
              { titulo: 'Große Besetzungen', texto: 'Komposition und Orchestration für Sinfonieorchester.' },
              { titulo: 'Große Formen', texto: 'Sinfonien, Solokonzerte und vollständige Opern.' },
            ],
          },
          {
            titulo: 'Warum diese Partituren tragen',
            items: [
              { titulo: 'Wirksam am Pult', texto: 'Als Chefdirigent des Sinfonieorchesters und des Sinfonischen Chors der Universidad Católica de Temuco und als Gastdirigent an der Oper in Santiago mit der Orquesta Filodramática de Chile weiß ich, was in der Probe hält und auf der Bühne trägt.' },
              { titulo: 'Wirkliche klangliche Balance', texto: 'Eine ausgewogene, spielbare Instrumentation, abgestimmt auf das, was Ihr Ensemble tatsächlich leisten kann.' },
              { titulo: 'Notensatz auf internationalem Niveau', texto: 'Partitur und Stimmen, vorbereitet für klares Lesen am Pult.' },
            ],
          },
        ],
      },
    },
    it: {
      descripcion: 'Un’opera originale, un arrangiamento misurato o un’orchestrazione che resti? Musica scritta sulla sua misura, dal podio.',
      ctaLabel: 'Commissionare un’opera',
      detalle: {
        gancho: 'Un’opera originale, un arrangiamento misurato o un’orchestrazione che resti? Musica scritta sulla sua misura, dal podio.',
        intro: 'Con oltre trent’anni sui podi internazionali, e una formazione al Conservatorio Reale di Bruxelles, metto l’esperienza del direttore d’orchestra e d’opera al servizio del suo progetto. Scrivo, arrangio e orchestro con il rigore che un grande palcoscenico esige, e con il senso musicale che raggiunge il pubblico.',
        cierreTitulo: 'Dia vita al suo prossimo progetto',
        cierre: 'Che si tratti di una canzone intima o di una produzione sinfonica, parliamone e diamo forma all’opera.',
        secciones: [
          {
            titulo: 'Composizione e orchestrazione su commissione',
            items: [
              { titulo: 'Musica popolare e canzoni', texto: 'Arrangiamenti stilizzati e una maquette professionale, per far fare alla musica il passo successivo.' },
              { titulo: 'Organici intimi', texto: 'Repertorio esclusivo per canto e pianoforte, o strumento solista e pianoforte.' },
              { titulo: 'Musica da camera', texto: 'Opere nuove e adattamenti esigenti per quartetto e quintetto.' },
              { titulo: 'Grandi organici', texto: 'Composizione e orchestrazione scritte per orchestra sinfonica.' },
              { titulo: 'Grandi forme', texto: 'Sinfonie, concerti solistici e opere liriche complete.' },
            ],
          },
          {
            titulo: 'Perché queste partiture funzionano',
            items: [
              { titulo: 'Efficaci sul leggio', texto: 'Direttore musicale dell’Orchestra e del Coro sinfonico dell’Universidad Católica de Temuco, e direttore ospite all’opera a Santiago con l’Orquesta Filodramática de Chile, so che cosa regge in prova e che cosa brilla in scena.' },
              { titulo: 'Un equilibrio sonoro vero', texto: 'Una strumentazione equilibrata, fluida e commisurata a ciò che il suo complesso può davvero fare.' },
              { titulo: 'Grafica musicale di standard internazionale', texto: 'Partitura e parti, preparate per una lettura chiara sul leggio.' },
            ],
          },
        ],
      },
    },
    pt: {
      descripcion: 'Uma obra original, um arranjo preciso ou uma orquestração com presença? Música escrita à sua medida, a partir do pódio.',
      ctaLabel: 'Encomendar uma obra',
      detalle: {
        gancho: 'Uma obra original, um arranjo preciso ou uma orquestração com presença? Música escrita à sua medida, a partir do pódio.',
        intro: 'Com mais de trinta anos em pódios internacionais e formação no Conservatório Real de Bruxelas, coloco a experiência de maestro e de diretor de ópera a serviço do seu projeto. Escrevo, arranjo e orquestro com o rigor que um grande palco exige e com o sentido musical que chega ao público.',
        cierreTitulo: 'Dê vida ao seu próximo projeto',
        cierre: 'Seja uma canção íntima ou uma produção sinfônica, vamos conversar e fazer a obra existir.',
        secciones: [
          {
            titulo: 'Composição e orquestração por encomenda',
            items: [
              { titulo: 'Música popular e canções', texto: 'Arranjos estilizados e uma maquete profissional, para a música dar o passo seguinte.' },
              { titulo: 'Formações íntimas', texto: 'Repertório exclusivo para canto e piano, ou instrumento solista e piano.' },
              { titulo: 'Música de câmara', texto: 'Obras novas e adaptações exigentes para quarteto e quinteto.' },
              { titulo: 'Grandes formações', texto: 'Composição e orquestração escritas para orquestra sinfônica.' },
              { titulo: 'Grandes formas', texto: 'Sinfonias, concertos e óperas completas.' },
            ],
          },
          {
            titulo: 'Por que estas partituras funcionam',
            items: [
              { titulo: 'Eficazes na estante', texto: 'Como diretor musical da Orquestra e do Coro Sinfônico da Universidad Católica de Temuco, e maestro convidado de ópera em Santiago com a Orquesta Filodramática de Chile, sei o que se sustenta no ensaio e o que brilha no palco.' },
              { titulo: 'Um equilíbrio sonoro real', texto: 'Instrumentação equilibrada, fluida e ajustada ao que o seu grupo realmente pode fazer.' },
              { titulo: 'Edição gráfica de padrão internacional', texto: 'Partitura geral e partes, preparadas para uma leitura clara na estante.' },
            ],
          },
        ],
      },
    },
  },
  orquestaciones: {
    en: {
      descripcion: 'An artist with a career, an established band, or a producer looking for a symphonic show that stays with the audience? This is the step onto the concert stage.',
      ctaLabel: 'Let us design your symphonic project',
      detalle: {
        gancho: 'An artist with a career, an established band, or a producer looking for a symphonic show that stays with the audience? This is the step onto the concert stage.',
        intro: 'Your repertoire, now symphonic. Professional orchestrations for soloists and established popular acts. More than thirty years as a conductor, trained at the Royal Conservatory of Brussels, go into turning songs and well-known hits into symphonic pieces with a real artistic life.',
        cierreTitulo: 'Take the music into a major house',
        cierre: 'Give your audience the experience of hearing these songs with the weight of a symphony orchestra. Write to me and we will design the symphonic project.',
        secciones: [
          {
            titulo: 'Symphonic crossover, written to order',
            items: [
              { titulo: 'Orchestration of popular hits', texto: 'Songs by well-known bands and soloists, scored as full symphonic works or for chamber ensemble.' },
              { titulo: 'Crossover shows and tributes', texto: 'Complete programmes in which rock, pop, folk or ballad repertoire sits with the scale of an orchestra.' },
              { titulo: 'Soloist and orchestra', texto: 'Orchestral frames written around your artistic identity: they lift the voice or the solo instrument, and they hold an audience.' },
              { titulo: 'Flexible scoring', texto: 'Written to sound right with a full symphony orchestra or with a hybrid band: rhythm section plus strings.' },
            ],
          },
          {
            titulo: 'A conductor’s hand on the page',
            intro: 'As Music Director of the Universidad Católica de Temuco Symphony Orchestra and Chorus, and as an opera conductor in Santiago for Merlín Comunicaciones with the Orquesta Filodramática de Chile, I know how to make strings, brass and woodwind speak cleanly with a drum kit or an electric guitar.',
            items: [
              { titulo: 'No surprises in rehearsal', texto: 'Practical scores that save the orchestra’s rehearsal time.' },
              { titulo: 'A real acoustic balance', texto: 'Careful writing in the frequency range, so the popular instruments and the orchestra are never fighting for the same space.' },
              { titulo: 'Engraving of a high standard', texto: 'Full score and parts, ready to read, to an international standard.' },
            ],
          },
        ],
      },
    },
    fr: {
      descripcion: 'Un artiste confirmé, un groupe établi ou un producteur en quête d’un spectacle symphonique qui marque ? C’est le passage à la scène de concert.',
      ctaLabel: 'Imaginons votre projet symphonique',
      detalle: {
        gancho: 'Un artiste confirmé, un groupe établi ou un producteur en quête d’un spectacle symphonique qui marque ? C’est le passage à la scène de concert.',
        intro: 'Votre répertoire, désormais symphonique. Orchestrations professionnelles pour solistes et formations populaires reconnues. Plus de trente ans de direction, après le Conservatoire royal de Bruxelles, pour faire de vos chansons et de vos succès de véritables pièces symphoniques.',
        cierreTitulo: 'Emmenez votre musique dans les grandes salles',
        cierre: 'Offrez à votre public l’expérience d’entendre ces chansons avec la puissance d’un orchestre symphonique. Écrivez-moi : nous dessinerons le projet.',
        secciones: [
          {
            titulo: 'Crossover symphonique sur mesure',
            items: [
              { titulo: 'Orchestration de succès populaires', texto: 'Les chansons de groupes et de solistes connus, écrites pour orchestre symphonique complet ou pour ensemble de chambre.' },
              { titulo: 'Spectacles crossover et hommages', texto: 'Programmes complets où le rock, la pop, le folklore ou la ballade dialoguent avec l’ampleur d’un orchestre.' },
              { titulo: 'Soliste et orchestre', texto: 'Un écrin orchestral qui respecte votre identité, porte la voix ou l’instrument soliste, et tient le public.' },
              { titulo: 'Effectifs souples', texto: 'Écrit pour sonner juste avec un grand orchestre comme avec une formation hybride : section rythmique et cordes.' },
            ],
          },
          {
            titulo: 'La main d’un chef sur la partition',
            intro: 'Directeur musical de l’Orchestre et du Chœur symphoniques de l’Universidad Católica de Temuco, et chef lyrique à Santiago pour Merlín Comunicaciones avec l’Orquesta Filodramática de Chile, je sais faire dialoguer cordes, cuivres et bois avec une batterie ou une guitare électrique.',
            items: [
              { titulo: 'Pas de surprise en répétition', texto: 'Des partitions efficaces, qui préservent le temps de répétition de l’orchestre.' },
              { titulo: 'Un équilibre acoustique réel', texto: 'Une écriture attentive aux fréquences, pour que les instruments populaires et l’orchestre ne se disputent pas le premier plan.' },
              { titulo: 'Gravure soignée', texto: 'Conducteur et parties, prêts à lire, aux standards internationaux.' },
            ],
          },
        ],
      },
    },
    de: {
      descripcion: 'Ein Künstler mit Laufbahn, eine etablierte Band oder eine Produktion, die ein sinfonisches Konzert sucht, das bleibt? Das ist der Schritt auf die Konzertbühne.',
      ctaLabel: 'Lassen Sie uns Ihr sinfonisches Projekt entwerfen',
      detalle: {
        gancho: 'Ein Künstler mit Laufbahn, eine etablierte Band oder eine Produktion, die ein sinfonisches Konzert sucht, das bleibt? Das ist der Schritt auf die Konzertbühne.',
        intro: 'Ihr Repertoire, nun sinfonisch. Professionelle Orchestrationen für Solistinnen, Solisten und etablierte Pop-Formationen. Über dreißig Jahre Dirigiererfahrung, ausgebildet am Königlichen Konservatorium Brüssel, um Songs und bekannte Hits in sinfonische Stücke mit eigenem künstlerischen Leben zu verwandeln.',
        cierreTitulo: 'Bringen Sie die Musik in die großen Häuser',
        cierre: 'Geben Sie Ihrem Publikum diese Songs mit dem Gewicht eines Sinfonieorchesters. Schreiben Sie mir, und wir entwerfen das Projekt.',
        secciones: [
          {
            titulo: 'Sinfonischer Crossover im Auftrag',
            items: [
              { titulo: 'Orchestration populärer Hits', texto: 'Songs bekannter Bands und Solistinnen, gesetzt für großes Sinfonieorchester oder für Kammerensemble.' },
              { titulo: 'Crossover-Shows und Tributes', texto: 'Ganze Programme, in denen Rock, Pop, Folklore oder Ballade mit dem Maßstab eines Orchesters zusammengehen.' },
              { titulo: 'Solist und Orchester', texto: 'Ein orchestraler Rahmen um Ihre künstlerische Identität: er trägt die Stimme oder das Soloinstrument und hält das Publikum.' },
              { titulo: 'Flexible Besetzung', texto: 'Geschrieben für ein großes Orchester ebenso wie für eine hybride Band: Rhythmusgruppe plus Streicher.' },
            ],
          },
          {
            titulo: 'Die Hand eines Dirigenten auf dem Papier',
            intro: 'Als Chefdirigent des Sinfonieorchesters und des Sinfonischen Chors der Universidad Católica de Temuco und als Operndirigent in Santiago für Merlín Comunicaciones mit der Orquesta Filodramática de Chile weiß ich, wie Streicher, Blech und Holz klar mit Schlagzeug oder E-Gitarre sprechen.',
            items: [
              { titulo: 'Keine Überraschung in der Probe', texto: 'Praktische Partituren, die der Probezeit des Orchesters dienen.' },
              { titulo: 'Wirkliche akustische Balance', texto: 'Sorgfältige Schreibweise im Frequenzbereich, damit populäre Instrumente und Orchester sich nicht denselben Raum streitig machen.' },
              { titulo: 'Notensatz auf hohem Niveau', texto: 'Partitur und Stimmen, lesefertig, nach internationalem Standard.' },
            ],
          },
        ],
      },
    },
    it: {
      descripcion: 'Un artista con una carriera, una band affermata o una produzione in cerca di uno spettacolo sinfonico che resti? È il passo verso il palcoscenico da concerto.',
      ctaLabel: 'Progettiamo il suo concerto sinfonico',
      detalle: {
        gancho: 'Un artista con una carriera, una band affermata o una produzione in cerca di uno spettacolo sinfonico che resti? È il passo verso il palcoscenico da concerto.',
        intro: 'Il suo repertorio, ora sinfonico. Orchestrazioni professionali per solisti e formazioni popolari consacrate. Oltre trent’anni di direzione, con una formazione al Conservatorio Reale di Bruxelles, per trasformare canzoni e successi in pagine sinfoniche con una vita artistica propria.',
        cierreTitulo: 'Porti la musica nei grandi teatri',
        cierre: 'Offra al suo pubblico queste canzoni con il peso di un’orchestra sinfonica. Mi scriva: disegniamo il progetto.',
        secciones: [
          {
            titulo: 'Crossover sinfonico su misura',
            items: [
              { titulo: 'Orchestrazione di successi popolari', texto: 'Le canzoni di band e solisti noti, scritte per orchestra sinfonica o per ensemble da camera.' },
              { titulo: 'Spettacoli crossover e tribute', texto: 'Programmi completi in cui rock, pop, folclore o ballata dialogano con la scala di un’orchestra.' },
              { titulo: 'Solista e orchestra', texto: 'Una cornice orchestrale intorno alla sua identità: sostiene la voce o lo strumento solista e tiene il pubblico.' },
              { titulo: 'Organici flessibili', texto: 'Scritte per una grande orchestra come per una formazione ibrida: sezione ritmica e archi.' },
            ],
          },
          {
            titulo: 'La mano di un direttore sulla pagina',
            intro: 'Direttore musicale dell’Orchestra e del Coro sinfonico dell’Universidad Católica de Temuco, e direttore lirico a Santiago per Merlín Comunicaciones con l’Orquesta Filodramática de Chile, so far dialogare archi, ottoni e legni con una batteria o una chitarra elettrica.',
            items: [
              { titulo: 'Nessuna sorpresa in prova', texto: 'Partiture pratiche, che risparmiano il tempo di prova dell’orchestra.' },
              { titulo: 'Un equilibrio acustico reale', texto: 'Una scrittura attenta alle frequenze, perché gli strumenti popolari e l’orchestra non si contendano lo stesso spazio.' },
              { titulo: 'Grafica di alto livello', texto: 'Partitura e parti, pronte da leggere, a standard internazionale.' },
            ],
          },
        ],
      },
    },
    pt: {
      descripcion: 'Um artista com trajetória, uma banda consagrada ou uma produtora em busca de um espetáculo sinfônico que fique? É o passo para o palco de concerto.',
      ctaLabel: 'Vamos desenhar o seu projeto sinfônico',
      detalle: {
        gancho: 'Um artista com trajetória, uma banda consagrada ou uma produtora em busca de um espetáculo sinfônico que fique? É o passo para o palco de concerto.',
        intro: 'O seu repertório, agora sinfônico. Orquestrações profissionais para solistas e grupos populares consagrados. Mais de trinta anos de direção, com formação no Conservatório Real de Bruxelas, para transformar canções e sucessos em peças sinfônicas com vida artística própria.',
        cierreTitulo: 'Leve a música às grandes salas',
        cierre: 'Dê ao seu público estas canções com o peso de uma orquestra sinfônica. Escreva-me e desenhamos o projeto.',
        secciones: [
          {
            titulo: 'Crossover sinfônico sob medida',
            items: [
              { titulo: 'Orquestração de sucessos populares', texto: 'Canções de bandas e solistas conhecidos, escritas para orquestra sinfônica ou para conjunto de câmara.' },
              { titulo: 'Espetáculos crossover e tributos', texto: 'Programas completos em que rock, pop, folclore ou balada convivem com a escala de uma orquestra.' },
              { titulo: 'Solista e orquestra', texto: 'Uma moldura orquestral em torno da sua identidade: sustenta a voz ou o instrumento solista e segura o público.' },
              { titulo: 'Formações flexíveis', texto: 'Escritas para uma grande orquestra e também para uma banda híbrida: base rítmica e cordas.' },
            ],
          },
          {
            titulo: 'A mão de um maestro na partitura',
            intro: 'Como diretor musical da Orquestra e do Coro Sinfônico da Universidad Católica de Temuco, e diretor lírico em Santiago para a Merlín Comunicaciones com a Orquesta Filodramática de Chile, sei fazer cordas, metais e madeiras dialogarem com uma bateria ou uma guitarra elétrica.',
            items: [
              { titulo: 'Sem surpresas no ensaio', texto: 'Partituras práticas, que poupam o tempo de ensaio da orquestra.' },
              { titulo: 'Um equilíbrio acústico real', texto: 'Escrita atenta às frequências, para que os instrumentos populares e a orquestra não disputem o mesmo espaço.' },
              { titulo: 'Edição gráfica de alto nível', texto: 'Partitura geral e partes, prontas para ler, em padrão internacional.' },
            ],
          },
        ],
      },
    },
  },
  transcripcionPartituras: {
    en: {
      descripcion: 'A tune on your phone, a manuscript your players cannot read, or an audio file you need as an exact score?',
      ctaLabel: 'Send the audio or the manuscript',
      detalle: {
        gancho: 'A tune on your phone, a manuscript your players cannot read, or an audio file you need as an exact score?',
        intro: 'From an idea, a recording or a manuscript, onto a professional page. Transcription and music engraving in whatever format you need. More than thirty years as a conductor and arranger, trained at the Royal Conservatory of Brussels, go into copying your music with technical accuracy and artistic fidelity.',
        cierreTitulo: 'Do not leave the music unwritten',
        cierre: 'Protect the work, put the catalogue in order, or prepare the material for copyright registration. Let us talk and give your scores a professional form.',
        secciones: [
          {
            titulo: 'Any music, into any format',
            items: [
              { titulo: 'From audio to score', texto: 'Songs, demos, live recordings, instrumental solos or complex pieces, taken from any audio file (MP3, WAV, video) onto the page.' },
              { titulo: 'From manuscript to a digital edition', texto: 'Handwritten scores and old drafts, turned into clean digital files, professionally engraved and free of copying errors.' },
              { titulo: 'Reductions and adaptations', texto: 'Orchestral scores reduced for solo piano, voice and piano, or a condensed rehearsal score.' },
              { titulo: 'From a lead sheet to standard notation', texto: 'Chord symbols, tablature or informal guides, written out in conventional notation for classically trained players. The reverse is also possible.' },
            ],
          },
          {
            titulo: 'A conductor’s standard of engraving',
            intro: 'As Music Director of the Universidad Católica de Temuco Symphony Orchestra and Chorus, I know how costly a badly engraved part is in rehearsal. These transcriptions guarantee:',
            items: [
              { titulo: 'Nothing left to guess', texto: 'A close check of harmony, rhythm, dynamics and articulation.' },
              { titulo: 'Clear on the stand', texto: 'Page layout and parts prepared in Sibelius or Finale, so your players do not lose time.' },
              { titulo: 'Files ready to use', texto: 'High-resolution PDF, editable files (MusicXML / Sibelius) and a reference audio (MIDI / MP3).' },
            ],
          },
        ],
      },
    },
    fr: {
      descripcion: 'Une mélodie dans votre téléphone, un manuscrit illisible pour vos musiciens, ou un fichier audio dont il vous faut la partition exacte ?',
      ctaLabel: 'Envoyez l’audio ou le manuscrit',
      detalle: {
        gancho: 'Une mélodie dans votre téléphone, un manuscrit illisible pour vos musiciens, ou un fichier audio dont il vous faut la partition exacte ?',
        intro: 'D’une idée, d’un enregistrement ou d’un manuscrit, à une page professionnelle. Transcription et gravure musicale, dans le format dont vous avez besoin. Plus de trente ans comme chef et arrangeur, formé au Conservatoire royal de Bruxelles, pour copier votre musique avec précision technique et fidélité artistique.',
        cierreTitulo: 'Ne laissez pas la musique sans partition',
        cierre: 'Protégez l’œuvre, mettez le catalogue en ordre, ou préparez le matériel pour le dépôt. Parlons-en et donnons à vos partitions une forme professionnelle.',
        secciones: [
          {
            titulo: 'Toute musique, dans tout format',
            items: [
              { titulo: 'De l’audio à la partition', texto: 'Chansons, maquettes, captations de concert, solos ou pièces complexes, depuis n’importe quel fichier (MP3, WAV, vidéo), mis sur la page.' },
              { titulo: 'Du manuscrit à l’édition numérique', texto: 'Partitions manuscrites et vieux brouillons, devenus des fichiers numériques propres, gravés avec soin et sans erreurs de copie.' },
              { titulo: 'Réductions et adaptations', texto: 'Partitions d’orchestre réduites pour piano seul, chant et piano, ou conducteur condensé de répétition.' },
              { titulo: 'De la grille à la notation traditionnelle', texto: 'Chiffrages, tablatures ou guides informels, mis en notation conventionnelle pour des musiciens de formation classique. L’inverse est possible.' },
            ],
          },
          {
            titulo: 'L’exigence d’un chef, dans la gravure',
            intro: 'Directeur musical de l’Orchestre et du Chœur symphoniques de l’Universidad Católica de Temuco, je sais ce que coûte en répétition une partie mal gravée. Ces transcriptions garantissent :',
            items: [
              { titulo: 'Rien laissé au hasard', texto: 'Une relecture serrée de l’harmonie, du rythme, des nuances et des articulations.' },
              { titulo: 'Lisible au pupitre', texto: 'Mise en page et parties préparées sous Sibelius ou Finale, pour ne pas faire perdre de temps à vos musiciens.' },
              { titulo: 'Fichiers prêts à l’emploi', texto: 'PDF haute résolution, fichiers éditables (MusicXML / Sibelius) et un audio de référence (MIDI / MP3).' },
            ],
          },
        ],
      },
    },
    de: {
      descripcion: 'Eine Melodie auf dem Telefon, ein Manuskript, das Ihre Musiker nicht lesen können, oder eine Audiodatei, aus der eine genaue Partitur werden soll?',
      ctaLabel: 'Audio oder Manuskript senden',
      detalle: {
        gancho: 'Eine Melodie auf dem Telefon, ein Manuskript, das Ihre Musiker nicht lesen können, oder eine Audiodatei, aus der eine genaue Partitur werden soll?',
        intro: 'Von einer Idee, einer Aufnahme oder einem Manuskript auf eine professionelle Seite. Transkription und Notensatz in dem Format, das Sie brauchen. Über dreißig Jahre als Dirigent und Arrangeur, ausgebildet am Königlichen Konservatorium Brüssel, um Ihre Musik technisch genau und künstlerisch treu zu übertragen.',
        cierreTitulo: 'Lassen Sie die Musik nicht ungeschrieben',
        cierre: 'Schützen Sie das Werk, ordnen Sie den Katalog oder bereiten Sie das Material für die Registrierung vor. Lassen Sie uns sprechen und den Partituren eine professionelle Form geben.',
        secciones: [
          {
            titulo: 'Jede Musik, in jedes Format',
            items: [
              { titulo: 'Vom Audio zur Partitur', texto: 'Songs, Demos, Live-Aufnahmen, Instrumentalsoli oder komplexe Stücke, aus jeder Audiodatei (MP3, WAV, Video) auf die Seite gebracht.' },
              { titulo: 'Vom Manuskript zur digitalen Ausgabe', texto: 'Handschriftliche Partituren und alte Entwürfe, als saubere digitale Dateien, professionell gesetzt und ohne Abschreibfehler.' },
              { titulo: 'Reduktionen und Bearbeitungen', texto: 'Orchesterpartituren, reduziert für Klavier allein, Gesang und Klavier oder als verkürzte Probenpartitur.' },
              { titulo: 'Vom Leadsheet zur traditionellen Notation', texto: 'Akkordsymbole, Tabulaturen oder informelle Skizzen, ausgeschrieben für klassisch ausgebildete Musiker. Auch der umgekehrte Weg ist möglich.' },
            ],
          },
          {
            titulo: 'Der Maßstab eines Dirigenten im Notensatz',
            intro: 'Als Chefdirigent des Sinfonieorchesters und des Sinfonischen Chors der Universidad Católica de Temuco weiß ich, was eine schlecht gesetzte Stimme in der Probe kostet. Diese Transkriptionen gewährleisten:',
            items: [
              { titulo: 'Nichts bleibt dem Raten überlassen', texto: 'Eine genaue Prüfung von Harmonie, Rhythmus, Dynamik und Artikulation.' },
              { titulo: 'Klar am Pult', texto: 'Satz und Stimmen in Sibelius oder Finale, damit Ihre Musiker keine Zeit verlieren.' },
              { titulo: 'Dateien, sofort verwendbar', texto: 'PDF in hoher Auflösung, editierbare Dateien (MusicXML / Sibelius) und ein Referenzton (MIDI / MP3).' },
            ],
          },
        ],
      },
    },
    it: {
      descripcion: 'Una melodia sul telefono, un manoscritto che i musicisti non riescono a leggere, o un file audio di cui le serve la partitura esatta?',
      ctaLabel: 'Invii l’audio o il manoscritto',
      detalle: {
        gancho: 'Una melodia sul telefono, un manoscritto che i musicisti non riescono a leggere, o un file audio di cui le serve la partitura esatta?',
        intro: 'Da un’idea, una registrazione o un manoscritto, a una pagina professionale. Trascrizione e grafica musicale nel formato che le serve. Oltre trent’anni come direttore e arrangiatore, formato al Conservatorio Reale di Bruxelles, per trascrivere la sua musica con precisione tecnica e fedeltà artistica.',
        cierreTitulo: 'Non lasci la musica senza partitura',
        cierre: 'Protegga l’opera, metta in ordine il catalogo o prepari il materiale per il deposito. Parliamone e diamo alle partiture una forma professionale.',
        secciones: [
          {
            titulo: 'Qualsiasi musica, in qualsiasi formato',
            items: [
              { titulo: 'Dall’audio alla partitura', texto: 'Canzoni, maquette, registrazioni dal vivo, assoli o brani complessi, da qualsiasi file (MP3, WAV, video) messi sulla pagina.' },
              { titulo: 'Dal manoscritto all’edizione digitale', texto: 'Partiture manoscritte e vecchie bozze, diventate file digitali puliti, incisi con cura e senza errori di copia.' },
              { titulo: 'Riduzioni e adattamenti', texto: 'Partiture orchestrali ridotte per pianoforte solo, canto e pianoforte, o partitura condensata di prova.' },
              { titulo: 'Dalla sigla alla notazione tradizionale', texto: 'Sigle americane, tablature o guide informali, scritte in notazione convenzionale per musicisti di formazione classica. È possibile anche il percorso inverso.' },
            ],
          },
          {
            titulo: 'Il criterio di un direttore, nella grafica',
            intro: 'Come direttore musicale dell’Orchestra e del Coro sinfonico dell’Universidad Católica de Temuco, so quanto costa in prova una parte incisa male. Queste trascrizioni garantiscono:',
            items: [
              { titulo: 'Niente lasciato all’intuizione', texto: 'Un controllo attento di armonia, ritmo, dinamiche e articolazioni.' },
              { titulo: 'Leggibile sul leggio', texto: 'Impaginazione e parti preparate in Sibelius o Finale, perché i musicisti non perdano tempo.' },
              { titulo: 'File pronti all’uso', texto: 'PDF ad alta risoluzione, file modificabili (MusicXML / Sibelius) e un audio di riferimento (MIDI / MP3).' },
            ],
          },
        ],
      },
    },
    pt: {
      descripcion: 'Uma melodia no telefone, um manuscrito que os músicos não conseguem ler, ou um áudio de que precisa a partitura exata?',
      ctaLabel: 'Envie o áudio ou o manuscrito',
      detalle: {
        gancho: 'Uma melodia no telefone, um manuscrito que os músicos não conseguem ler, ou um áudio de que precisa a partitura exata?',
        intro: 'De uma ideia, uma gravação ou um manuscrito, para uma página profissional. Transcrição e edição gráfica no formato de que precisa. Mais de trinta anos como maestro e arranjador, formado no Conservatório Real de Bruxelas, para transcrever a sua música com precisão técnica e fidelidade artística.',
        cierreTitulo: 'Não deixe a música sem partitura',
        cierre: 'Proteja a obra, organize o catálogo ou prepare o material para o registo. Vamos conversar e dar às partituras uma forma profissional.',
        secciones: [
          {
            titulo: 'Qualquer música, em qualquer formato',
            items: [
              { titulo: 'Do áudio à partitura', texto: 'Canções, maquetes, gravações ao vivo, solos ou peças complexas, a partir de qualquer arquivo (MP3, WAV, vídeo), passados para a página.' },
              { titulo: 'Do manuscrito à edição digital', texto: 'Partituras manuscritas e rascunhos antigos, convertidos em arquivos digitais limpos, editados com cuidado e sem erros de cópia.' },
              { titulo: 'Reduções e adaptações', texto: 'Partituras orquestrais reduzidas para piano solo, canto e piano, ou partitura condensada de ensaio.' },
              { titulo: 'Da cifra à notação tradicional', texto: 'Cifras, tablaturas ou guias informais, escritos em notação convencional para músicos de formação clássica. O caminho inverso também é possível.' },
            ],
          },
          {
            titulo: 'O critério de um maestro, na edição',
            intro: 'Como diretor musical da Orquestra e do Coro Sinfônico da Universidad Católica de Temuco, sei o que custa num ensaio uma parte mal editada. Estas transcrições garantem:',
            items: [
              { titulo: 'Nada fica por adivinhar', texto: 'Uma revisão atenta de harmonia, ritmo, dinâmicas e articulações.' },
              { titulo: 'Legível na estante', texto: 'Paginação e partes preparadas em Sibelius ou Finale, para os músicos não perderem tempo.' },
              { titulo: 'Arquivos prontos a usar', texto: 'PDF em alta resolução, arquivos editáveis (MusicXML / Sibelius) e um áudio de referência (MIDI / MP3).' },
            ],
          },
        ],
      },
    },
  },
  arreglosCorales: {
    en: {
      descripcion: 'A repertoire that asks something of your singers, moves the audience, and balances from the first rehearsal?',
      ctaLabel: 'Commission a choral arrangement',
      detalle: {
        gancho: 'A repertoire that asks something of your singers, moves the audience, and balances from the first rehearsal?',
        intro: 'Voices with a life of their own: professional choral arrangements for every kind of choir. Music written to your ensemble, by a conductor with an international career. More than thirty years of choral and orchestral conducting, after the Royal Conservatory of Brussels, go into arrangements that fit the voices and the style you actually have.',
        cierreTitulo: 'Give your choir a repertoire of its own',
        cierre: 'Let the choir shine with arrangements written for those voices. We can talk through your next choral season.',
        secciones: [
          {
            titulo: 'Choral writing for every repertoire',
            items: [
              { titulo: 'Crossover and popular music', texto: 'Choral versions of a high standard for pop, rock, Chilean and Latin American folk, jazz and ballads.' },
              { titulo: 'Classical and sacred music', texto: 'Original works and adaptations of classical or liturgical repertoire, written with scholarly care.' },
              { titulo: 'Large choral-orchestral works', texto: 'Orchestral reductions, adaptations, or large-scale arrangements ready to be performed with orchestra.' },
            ],
          },
          {
            titulo: 'Written for the voices you have',
            intro: 'Whatever the choir’s layout, the score is designed for how it actually sounds, and for vocal comfort:',
            items: [
              { titulo: 'Mixed choir', texto: 'Standard SATB, and larger divisi (SSAATTBB).' },
              { titulo: 'Equal voices', texto: 'Treble choirs (SSA / SSAA) or lower voices (TTBB).' },
              { titulo: 'Youth, children’s and school choirs', texto: 'SA / SAB, with tessitura and range kept suitable for developing voices.' },
              { titulo: 'Intimate vocal ensembles', texto: 'Quartets and quintets, a cappella.' },
            ],
          },
          {
            titulo: 'A chorus master’s hand on every score',
            intro: 'As founder and Music Director of the Symphony Chorus of the Universidad Católica de Temuco, and with a long record of leading choirs in Europe and Chile, including the Coro de la Universidad de Concepción, I know the real problems of choral singing:',
            items: [
              { titulo: 'Voice-leading that singers can trust', texto: 'Melodic lines that are fluent and logical, so tuning and memorising come more easily.' },
              { titulo: 'Tessitura treated with care', texto: 'Each voice part written in a comfortable range, so the choir does not tire.' },
              { titulo: 'Engraving that saves rehearsal', texto: 'Clear, clean scores to an international standard, so rehearsal time goes to the music.' },
            ],
          },
        ],
      },
    },
    fr: {
      descripcion: 'Un répertoire qui demande quelque chose à vos chanteurs, touche le public, et sonne juste dès la première répétition ?',
      ctaLabel: 'Commander un arrangement choral',
      detalle: {
        gancho: 'Un répertoire qui demande quelque chose à vos chanteurs, touche le public, et sonne juste dès la première répétition ?',
        intro: 'Des voix qui ont une vie propre : arrangements choraux professionnels pour tous les effectifs. Une musique écrite pour votre chœur, par un chef de carrière internationale. Plus de trente ans de direction chorale et orchestrale, après le Conservatoire royal de Bruxelles, pour des arrangements qui épousent les voix et le style que vous avez réellement.',
        cierreTitulo: 'Offrez à votre chœur un répertoire à lui',
        cierre: 'Laissez l’ensemble briller avec des arrangements écrits pour ces voix. Nous pouvons parler de votre prochaine saison chorale.',
        secciones: [
          {
            titulo: 'Une écriture chorale pour chaque répertoire',
            items: [
              { titulo: 'Crossover et musique populaire', texto: 'Versions chorales soignées pour la pop, le rock, le folklore chilien et latino-américain, le jazz et la ballade.' },
              { titulo: 'Musique savante et sacrée', texto: 'Œuvres originales et adaptations du répertoire classique ou liturgique, avec une exigence de métier.' },
              { titulo: 'Grandes œuvres symphonico-chorales', texto: 'Réductions d’orchestre, adaptations ou arrangements de grande ampleur, prêts à dialoguer avec un orchestre.' },
            ],
          },
          {
            titulo: 'Écrit pour les voix que vous avez',
            intro: 'Quelle que soit la formation, la partition est pensée pour le son réel du chœur et pour le confort vocal :',
            items: [
              { titulo: 'Chœur mixte', texto: 'SATB traditionnel, et divisions plus larges (SSAATTBB).' },
              { titulo: 'Voix égales', texto: 'Chœurs de voix aiguës (SSA / SSAA) ou de voix graves (TTBB).' },
              { titulo: 'Chœurs de jeunes, d’enfants ou scolaires', texto: 'SA / SAB, en gardant une tessiture et un ambitus adaptés aux voix en formation.' },
              { titulo: 'Ensembles vocaux intimes', texto: 'Quatuors et quintettes a cappella.' },
            ],
          },
          {
            titulo: 'La main d’un chef de chœur sur chaque partition',
            intro: 'Fondateur et directeur musical du Chœur symphonique de l’Universidad Católica de Temuco, et après avoir longtemps dirigé des ensembles en Europe et au Chili, dont le Coro de la Universidad de Concepción, je connais les vraies difficultés du chant choral :',
            items: [
              { titulo: 'Un conduit des voix que l’on peut chanter', texto: 'Des lignes mélodiques fluides et logiques, qui aident la justesse et la mémorisation.' },
              { titulo: 'La tessiture ménagée', texto: 'Chaque pupitre écrit dans une zone confortable, pour éviter la fatigue vocale.' },
              { titulo: 'Une gravure qui sert la répétition', texto: 'Partitions claires, aux standards internationaux, pour que le temps de travail aille à la musique.' },
            ],
          },
        ],
      },
    },
    de: {
      descripcion: 'Ein Repertoire, das Ihren Sängerinnen etwas abverlangt, das Publikum bewegt und schon in der ersten Probe im Gleichgewicht ist?',
      ctaLabel: 'Ein Chorarrangement in Auftrag geben',
      detalle: {
        gancho: 'Ein Repertoire, das Ihren Sängerinnen etwas abverlangt, das Publikum bewegt und schon in der ersten Probe im Gleichgewicht ist?',
        intro: 'Stimmen mit eigenem Leben: professionelle Chorarrangements für jede Besetzung. Musik, geschrieben für Ihren Chor, von einem Dirigenten mit internationaler Laufbahn. Über dreißig Jahre Chor- und Orchesterleitung, nach dem Königlichen Konservatorium Brüssel, für Arrangements, die zu den Stimmen und zum Stil passen, die Sie wirklich haben.',
        cierreTitulo: 'Geben Sie Ihrem Chor ein eigenes Repertoire',
        cierre: 'Lassen Sie das Ensemble mit Arrangements glänzen, die für diese Stimmen geschrieben sind. Wir können über Ihre nächste Chorsaison sprechen.',
        secciones: [
          {
            titulo: 'Chorsatz für jedes Repertoire',
            items: [
              { titulo: 'Crossover und populäre Musik', texto: 'Chorfassungen auf hohem Niveau für Pop, Rock, chilenische und lateinamerikanische Folklore, Jazz und Balladen.' },
              { titulo: 'Kunst- und geistliche Musik', texto: 'Originalwerke und Bearbeitungen des klassischen oder liturgischen Repertoires, mit handwerklicher Sorgfalt.' },
              { titulo: 'Große choralsinfonische Werke', texto: 'Orchesterreduktionen, Bearbeitungen oder groß besetzte Arrangements, bereit für das Zusammenspiel mit Orchester.' },
            ],
          },
          {
            titulo: 'Geschrieben für die Stimmen, die Sie haben',
            intro: 'Wie der Chor auch besetzt ist: die Partitur ist auf den wirklichen Klang und auf vokale Bequemlichkeit hin angelegt:',
            items: [
              { titulo: 'Gemischter Chor', texto: 'Klassisches SATB und größere Teilungen (SSAATTBB).' },
              { titulo: 'Gleiche Stimmen', texto: 'Hohe Stimmen (SSA / SSAA) oder tiefe Stimmen (TTBB).' },
              { titulo: 'Jugend-, Kinder- und Schulchöre', texto: 'SA / SAB, mit einer Tessitur und einem Umfang, die zu Stimmen in der Entwicklung passen.' },
              { titulo: 'Intime Vokalensembles', texto: 'Quartette und Quintette a cappella.' },
            ],
          },
          {
            titulo: 'Die Hand eines Chordirigenten auf jeder Partitur',
            intro: 'Als Gründer und Chefdirigent des Sinfonischen Chors der Universidad Católica de Temuco, und nach langer Leitung von Chören in Europa und Chile, darunter der Coro de la Universidad de Concepción, kenne ich die wirklichen Fragen des Chorgesangs:',
            items: [
              { titulo: 'Stimmführung, der man folgen kann', texto: 'Fließende, logische Melodielinien, die Intonation und Auswendiglernen erleichtern.' },
              { titulo: 'Tessitur mit Sorgfalt', texto: 'Jede Stimmgruppe in einem bequemen Bereich, damit der Chor nicht ermüdet.' },
              { titulo: 'Notensatz, der der Probe dient', texto: 'Klare Partituren nach internationalem Standard, damit die Probenzeit der Musik gehört.' },
            ],
          },
        ],
      },
    },
    it: {
      descripcion: 'Un repertorio che chiede qualcosa ai cantanti, commuove il pubblico e trova l’equilibrio già dalla prima prova?',
      ctaLabel: 'Commissionare un arrangiamento corale',
      detalle: {
        gancho: 'Un repertorio che chiede qualcosa ai cantanti, commuove il pubblico e trova l’equilibrio già dalla prima prova?',
        intro: 'Voci con una vita propria: arrangiamenti corali professionali per ogni organico. Musica scritta per il suo coro, da un direttore di carriera internazionale. Oltre trent’anni di direzione corale e orchestrale, dopo il Conservatorio Reale di Bruxelles, per arrangiamenti che aderiscono alle voci e allo stile che ha davvero.',
        cierreTitulo: 'Dia al coro un repertorio suo',
        cierre: 'Lasci brillare l’ensemble con arrangiamenti scritti per quelle voci. Possiamo parlare della prossima stagione corale.',
        secciones: [
          {
            titulo: 'Scrittura corale per ogni repertorio',
            items: [
              { titulo: 'Crossover e musica popolare', texto: 'Versioni corali di alto livello per pop, rock, folclore cileno e latinoamericano, jazz e ballate.' },
              { titulo: 'Musica colta e sacra', texto: 'Opere originali e adattamenti del repertorio classico o liturgico, con rigore di mestiere.' },
              { titulo: 'Grandi opere sinfonico-corali', texto: 'Riduzioni orchestrali, adattamenti o arrangiamenti di grande organico, pronti a dialogare con l’orchestra.' },
            ],
          },
          {
            titulo: 'Scritto per le voci che ha',
            intro: 'Qualunque sia la formazione, la partitura è pensata per il suono reale del coro e per il comfort vocale:',
            items: [
              { titulo: 'Coro misto', texto: 'SATB tradizionale e divisioni più ampie (SSAATTBB).' },
              { titulo: 'Voci pari', texto: 'Cori di voci acute (SSA / SSAA) o di voci gravi (TTBB).' },
              { titulo: 'Cori giovanili, di voci bianche o scolastici', texto: 'SA / SAB, con tessitura e estensione adatte a voci in formazione.' },
              { titulo: 'Ensemble vocali intimi', texto: 'Quartetti e quintetti a cappella.' },
            ],
          },
          {
            titulo: 'La mano di un direttore di coro su ogni partitura',
            intro: 'Fondatore e direttore musicale del Coro sinfonico dell’Universidad Católica de Temuco, e dopo una lunga direzione di complessi in Europa e in Cile, tra cui il Coro de la Universidad de Concepción, conosco i problemi reali del canto corale:',
            items: [
              { titulo: 'Un conducimento che si può cantare', texto: 'Linee melodiche fluide e logiche, che aiutano l’intonazione e la memoria.' },
              { titulo: 'Tessitura trattata con cura', texto: 'Ogni sezione scritta in una zona comoda, per evitare l’affaticamento vocale.' },
              { titulo: 'Una grafica che serve la prova', texto: 'Partiture chiare, a standard internazionale, perché il tempo di lavoro vada alla musica.' },
            ],
          },
        ],
      },
    },
    pt: {
      descripcion: 'Um repertório que pede algo aos cantores, emociona o público e equilibra já no primeiro ensaio?',
      ctaLabel: 'Encomendar um arranjo coral',
      detalle: {
        gancho: 'Um repertório que pede algo aos cantores, emociona o público e equilibra já no primeiro ensaio?',
        intro: 'Vozes com vida própria: arranjos corais profissionais para todo o tipo de formação. Música escrita para o seu coro, por um maestro de trajetória internacional. Mais de trinta anos de direção coral e orquestral, depois do Conservatório Real de Bruxelas, em arranjos que se ajustam às vozes e ao estilo que realmente tem.',
        cierreTitulo: 'Dê ao coro um repertório seu',
        cierre: 'Deixe o grupo brilhar com arranjos escritos para essas vozes. Podemos falar da sua próxima temporada coral.',
        secciones: [
          {
            titulo: 'Escrita coral para cada repertório',
            items: [
              { titulo: 'Crossover e música popular', texto: 'Versões corais de alto nível para pop, rock, folclore chileno e latino-americano, jazz e balada.' },
              { titulo: 'Música erudita e sacra', texto: 'Obras originais e adaptações do repertório clássico ou litúrgico, com rigor de ofício.' },
              { titulo: 'Grandes obras sinfônico-corais', texto: 'Reduções orquestrais, adaptações ou arranjos de grande efetivo, prontos para dialogar com a orquestra.' },
            ],
          },
          {
            titulo: 'Escrito para as vozes que tem',
            intro: 'Seja qual for a formação, a partitura é pensada para o som real do coro e para o conforto vocal:',
            items: [
              { titulo: 'Coro misto', texto: 'SATB tradicional e divisões mais amplas (SSAATTBB).' },
              { titulo: 'Vozes iguais', texto: 'Coros de vozes agudas (SSA / SSAA) ou de vozes graves (TTBB).' },
              { titulo: 'Coros juvenis, infantis ou escolares', texto: 'SA / SAB, com tessitura e extensão adequadas a vozes em formação.' },
              { titulo: 'Conjuntos vocais íntimos', texto: 'Quartetos e quintetos a cappella.' },
            ],
          },
          {
            titulo: 'A mão de um diretor de coro em cada partitura',
            intro: 'Como fundador e diretor musical do Coro Sinfônico da Universidad Católica de Temuco, e depois de uma longa direção de grupos na Europa e no Chile, entre eles o Coro de la Universidad de Concepción, conheço os problemas reais do canto coral:',
            items: [
              { titulo: 'Um conduzir de vozes que se pode cantar', texto: 'Linhas melódicas fluidas e lógicas, que facilitam a afinação e a memorização.' },
              { titulo: 'Tessitura tratada com cuidado', texto: 'Cada naipe escrito numa zona confortável, para evitar a fadiga vocal.' },
              { titulo: 'Uma edição que serve o ensaio', texto: 'Partituras claras, em padrão internacional, para o tempo de trabalho ir para a música.' },
            ],
          },
        ],
      },
    },
  },
  otrosArreglos: {
    en: {
      ctaLabel: 'Request a quote',
      detalle: {
        cierreTitulo: 'Coming soon',
        secciones: [{ titulo: 'Provisional text', items: [{ titulo: 'Provisional' }] }],
      },
    },
    fr: {
      ctaLabel: 'Demander un devis',
      detalle: {
        cierreTitulo: 'À venir',
        secciones: [{ titulo: 'Texte provisoire', items: [{ titulo: 'Provisoire' }] }],
      },
    },
    de: {
      ctaLabel: 'Anfrage senden',
      detalle: {
        cierreTitulo: 'In Kürze',
        secciones: [{ titulo: 'Vorläufiger Text', items: [{ titulo: 'Vorläufig' }] }],
      },
    },
    it: {
      ctaLabel: 'Richiedere un preventivo',
      detalle: {
        cierreTitulo: 'In arrivo',
        secciones: [{ titulo: 'Testo provvisorio', items: [{ titulo: 'Provvisorio' }] }],
      },
    },
    pt: {
      ctaLabel: 'Pedir um orçamento',
      detalle: {
        cierreTitulo: 'Em breve',
        secciones: [{ titulo: 'Texto provisório', items: [{ titulo: 'Provisório' }] }],
      },
    },
  },
}
